// Version : 0.0.1
// Author : Agalya

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** *********************  START FETCH BUSINESS LOAN INDEX DETAILS  ******************** */
export const fetchBusinessLoanIndex = (fetchData: any) => {
	const data = {
		BusinessLoanIndexDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchBusinessBasedLoanIndex`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH BUSINESS LOAN INDEX DETAILS  ******************** */

/** *********************  START FETCH FINANCE BASED ACCOUNT TYPE DETAILS  ******************** */
export const fetchFinanceBasaedAccountTypeDetails = (fetchFinanceBasaedAccountType: any) => {
	const data = {
		FinanceBasedTypeDetailsToken: fetchFinanceBasaedAccountType,
	};
	const url = `${API_URL}fetchFinanceAccountBaseType`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH FINANCE BASED ACCOUNT TYPE DETAILS  ******************** */

/** *********************  START CREATE LOAN DISBURSEMENT  ******************** */
export const createLoanDisbursement = (loanDisbursement: any) => {
	const data = {
		CreateBusinessLoanDisbursement: loanDisbursement,
	};
	const url = `${API_URL}businessLoanIndexDisbursement`;
	return makeApiCall(url, data);
};
/** *********************  END CREATE LOAN DISBURSEMENT  ******************** */

/** *********************  START FETCH BUSINESS LOAN INFO DETAILS  ******************** */
export const fetchBasedOnBusinessLoanInfo = (fetchLoan: any) => {
	const data = {
		BusinessLoanInfoDetailsToken: fetchLoan,
	};
	const url = `${API_URL}getLoanInfoBasedBusinessLoanStatus`;
	return makeApiCall(url, data);
};
/** *********************  END FETCH BUSINESS LOAN INFO DETAILS  ******************** */

/** *********************  START GET BUSINESS LIST  ******************** */
export const getBusinessList = (businessData: any) => {
	const data = {
		GetBusinessListDataToken: businessData,
	};
	const url = `${API_URL}getBusinessList`;
	return makeApiCall(url, data);
};
/** *********************  END GET BUSINESS LIST  ******************** */
